import { useMemo } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { useCategoryContext } from '../../CategoryProvider';
import { ArrowTopRight } from '../../../../../Common/Icon';
import { CategoryByIdSubCategory } from '../../../../../../store/category/byId';

import styles from './index.module.scss';

interface SubCategoryRowProps {
  categoryId: string;
  subCategory: CategoryByIdSubCategory;
}

export const SubCategoryRow = ({
  categoryId,
  subCategory: item,
}: SubCategoryRowProps) => {
  const { subCategory, setSubCategory, displayMode } = useCategoryContext();
  const values: {
    customer: { percent: string; dollar: string };
    worker: { percent: string; dollar: string };
  } = useMemo(
    () => ({
      customer: {
        percent: `${Math.round(subCategory?.customerAvgPercent || 0)}%`,
        dollar: `$${Math.round(subCategory?.customerAvgValue || 0)}`,
      },
      worker: {
        percent: `${Math.round(subCategory?.workerAvgPercent || 0)}%`,
        dollar: `$${Math.round(subCategory?.workerAvgValue || 0)}`,
      },
    }),
    [subCategory]
  );

  return (
    <div
      key={item.id}
      className={clsx(
        styles.subCategoryRow,
        item.id === subCategory?.id && styles.active
      )}
      onClick={() => setSubCategory(item)}
    >
      <div className={styles.nameWrapper}>
        <span className={styles.name}>{item.header}</span>
        <Link
          to={`/categories/${categoryId}/${item.id}`}
          className={styles.button}
        >
          <ArrowTopRight />
          More Information
        </Link>
      </div>
      <div className={styles.value}>{values.customer[displayMode]}</div>
      <div className={clsx(styles.value, styles.gaExpected)}>
        {values.worker[displayMode]}
      </div>
    </div>
  );
};
